<script>
import { mapGetters, mapActions, mapState } from "vuex";
import NavigationWrapper from "@/components/NavigationWrapper";
import CardTableLinkIndicator from "@/components/CardTableLinkIndicator";

export default {
  // Included components
  components: {
    NavigationWrapper,
    CardTableLinkIndicator,
  },

  computed: {
    // Mapped vuex state
    ...mapGetters(["activeTeam"]),
    ...mapState(["teamMembers"]),
  },

  // When the component is created, get the team members
  async created() {
    await Promise.all([
      this.getTeamMembers(
        "account.id,account.name,account.handle,account.email,role.name"
      ),
      this.getRoles("id", "name"),
    ]);
  },

  methods: {
    // Go to the details page for the member
    goToMember(member) {
      this.$router.push({
        name: "teamMember",
        params: { memberId: member.id },
      });
    },

    // Mapped vuex actions
    ...mapActions(["getTeams", "getTeamMembers", "getRoles"]),
  },
};
</script>

<template>
  <NavigationWrapper>
    <template #breadcrumbs>
      <b-breadcrumb-item to="/team">Settings</b-breadcrumb-item>
      <b-breadcrumb-item active>Members</b-breadcrumb-item>
    </template>
    <h1 class="mb-3">Members</h1>
    <b-row>
      <b-col>
        <b-card class="Card-table Card-table-hoverable">
          <b-card-text>
            <b-table
              responsive
              small
              :fields="[
                {
                  key: 'email',
                  label: 'Email',
                  sortable: true,
                },
                {
                  key: 'name',
                  label: 'Name',
                  sortable: true,
                },
                {
                  key: 'handle',
                  label: 'Handle',
                  sortable: true,
                  formatter(value, key, item) {
                    return `@${value}`;
                  },
                },
                {
                  key: 'role.name',
                  label: 'Role',
                  sortable: true,
                },
              ]"
              :items="Object.values(teamMembers)"
              @row-clicked="goToMember"
            >
              <template #cell(email)="{ item }">
                {{ item.email }}
                <CardTableLinkIndicator />
              </template>
            </b-table>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </NavigationWrapper>
</template>
